import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const FocalMapContext = createContext({ map: {}, refresh: () => {} });

// Treat "https://site/api/files/x.jpg?v=1", "/api/files/x.jpg" and "/files/x.jpg" as the same image.
export function normalizeImageKey(url) {
    if (!url || typeof url !== "string") return "";
    let u = url.trim().replace(/^https?:\/\/[^/]+/i, "").split(/[?#]/)[0];
    if (u.startsWith("/api/")) u = u.slice(4);
    return u;
}

export function FocalMapProvider({ children }) {
    const [map, setMap] = useState({});

    const refresh = () => {
        api.get("/image-focal-map")
            .then((r) => {
                const norm = {};
                Object.entries(r.data || {}).forEach(([k, v]) => { norm[normalizeImageKey(k)] = v; });
                setMap(norm);
            })
            .catch(() => {});
    };

    useEffect(() => {
        refresh();
    }, []);

    return (
        <FocalMapContext.Provider value={{ map, refresh }}>
            {children}
        </FocalMapContext.Provider>
    );
}

export function useFocalMap() {
    return useContext(FocalMapContext);
}

// Returns undefined (no override) when no focal point is set, so the element's
// existing `object-*` Tailwind class (e.g. object-top) keeps working by default.
export function getFocalPoint(map, src) {
    return (src && map[normalizeImageKey(src)]) || undefined;
}

export function getObjectPosition(map, src) {
    const point = getFocalPoint(map, src);
    if (!point) return undefined;
    const [x, y] = point;
    return `${x}% ${y}%`;
}
